import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { SelectedGoalsResponseApi } from '../types/api/goals';

type StateWithUser = { user: { userData?: { token?: string } | null } };

export const goalsApiSlice = createApi({
  reducerPath: 'goalsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BACKEND_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as StateWithUser).user.userData?.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['SelectedGoals'],
  endpoints: (builder) => ({
    fetchSelectedGoals: builder.query<SelectedGoalsResponseApi, void>({
      query: () => '/goals/selected',
      providesTags: [{ type: 'SelectedGoals', id: 'LIST' }],
    }),
    addSelectedGoal: builder.mutation<void, string>({
      query: (goalId) => ({
        url: `/goals/selected/${goalId}`,
        method: 'PUT',
      }),
      invalidatesTags: [{ type: 'SelectedGoals', id: 'LIST' }],
    }),
    deleteSelectedGoal: builder.mutation<void, string>({
      query: (goalId) => ({
        url: `/goals/selected/${goalId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'SelectedGoals', id: 'LIST' }],
    }),
  }),
});

export const {
  useFetchSelectedGoalsQuery,
  useAddSelectedGoalMutation,
  useDeleteSelectedGoalMutation,
} = goalsApiSlice;
